import { v2Request } from "../helpers/request";

export const getConversionList = () => {
  return v2Request(`/chats/list`);
};

export const getChatMessages = (chatId: number) => {
  return v2Request(`/chats/messages/${chatId}`);
};

export const fetchUnreadMessages = () => {
  return v2Request(`/chats/unread`);
};

export const markChatAsRead = (chatId: number) => {
  // This will be implemented with socket.io
  return { chatId };
};

export const deleteChat = (chatId: number) => {
  return v2Request(`/chats/${chatId}`, {
    method: "DELETE",
  });
};

export const getChatAppointments = (chatId: number) => {
  return v2Request(`/chats/${chatId}/appointments`);
};

export const getDelegateChatList = (params?: {
  page?: number;
  limit?: number;
  search?: string;
  officeId?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.search) qs.set("search", params.search);
  if (params?.officeId) qs.set("officeId", String(params.officeId));
  const query = qs.toString();
  return v2Request(`/chats/delegate-list${query ? `?${query}` : ""}`);
};

export const getDelegateChatMessages = (
  chatId: number,
  officeId: number,
  page = 1,
  limit = 50
) => {
  return v2Request(
    `/chats/delegate-messages/${chatId}?officeId=${officeId}&page=${page}&limit=${limit}`
  );
};

export const getDelegateChatAppointmentsData = (chatId: number, officeId: number) => {
  return v2Request(`/chats/delegate-appointments/${chatId}?officeId=${officeId}`);
};

export const getDelegateRepDetails = (repId: number, officeId: number) => {
  return v2Request(`/chats/delegate-rep-details/${repId}?officeId=${officeId}`);
};

export const getOfficeChatReps = (search = "", limit = 20) => {
  const qs = new URLSearchParams({ limit: String(limit) });
  if (search) qs.set("search", search);
  return v2Request(`/users/office-chat-reps?${qs.toString()}`);
};

export const deleteDelegateChat = (chatId: number, officeId: number) => {
  return v2Request(`/chats/delegate-delete/${chatId}?officeId=${officeId}`, {
    method: "DELETE",
  });
};

export const getDelegateRepAppointments = (payload: {
  repId: number;
  officeIdFilter: number;
  page?: number;
  pageSize?: number;
}) => {
  return v2Request("/appointments/rep-appointments-delegate", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });
};
